import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import classnames from 'classnames';

import { Input, version2 } from 'ui-components/components/input';
import { Text, TextType } from 'ui-components/components/text';
import messages from '../messages';
import style from './buttons.module.less';

export const CompanyNameAndPhoneQuestion = ({ phoneNumber = '', setPhoneNumer, companyName = '', setCompanyName }) => {
  const intl = useIntl();
  return (
    <div className={style['company-name-phone-container']}>
      <Input
        aria-label={intl.formatMessage(messages.companyName)}
        className={classnames(style['input-label'], style['company-name'])}
        label={intl.formatMessage(messages.companyName)}
        onChange={setCompanyName}
        value={companyName}
        version={version2}
      />
      <Input
        aria-label={intl.formatMessage(messages.phoneNumber)}
        className={style['input-label']}
        label={intl.formatMessage(messages.phoneNumber)}
        onChange={setPhoneNumer}
        value={phoneNumber}
        version={version2}
      />
      <Text className={style['phone-explainer']} textType={TextType.Caption} value={messages.phoneExplainer} />
    </div>
  );
};

CompanyNameAndPhoneQuestion.propTypes = {
  phoneNumber: PropTypes.string,
  setPhoneNumer: PropTypes.func.isRequired,
  companyName: PropTypes.string,
  setCompanyName: PropTypes.func.isRequired,
};
